



























































































































import IListExciseDrinkCategory from '@/store/models/IListExciseDrinkCategory';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListExciseDrinkCategoriesSelector extends Vue {
    searchListExciseDrinkCategories: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListExciseDrinkCategory = {
        id: "",
        name: ""
    }
    defaultItem : IListExciseDrinkCategory = {
        id: "",
        name: ""
    }

    @Prop({ type: Array, required: true })
    ListExciseDrinkCategoriesList !: IListExciseDrinkCategory[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListExciseDrinkCategories : IListExciseDrinkCategory[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Excise Tariff Category' : 'Edit Excise Tariff Category'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListExciseDrinkCategories() {
        this.selectedListExciseDrinkCategories = [];
    }

    editListExciseDrinkCategory (item: any, dbox = true) {
        this.editedIndex = this.ListExciseDrinkCategoriesList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    saveListExciseDrinkCategory () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListExciseDrinkCategories[0]) {
                this.close();
                this.$emit('editListExciseDrinkCategory', this.editedItem);
                Object.assign(this.ListExciseDrinkCategoriesList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListExciseDrinkCategories[0] = this.editedItem;
                this.$emit('saveListExciseDrinkCategory', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListExciseDrinkCategory (listExciseDrinkCategory: IListExciseDrinkCategory) {
        this.$emit('deleteListExciseDrinkCategory', listExciseDrinkCategory);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListExciseDrinkCategories(item : any) : void {
        if (!this.selectedListExciseDrinkCategories.includes(item)) {
            this.selectedListExciseDrinkCategories = [];
            this.selectedListExciseDrinkCategories = [item];
        } else {
            this.selectedListExciseDrinkCategories = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
